import styled from "styled-components";

export const ProductWarranteeDetailContainerStyled = styled.div`
  .info_timeline_row {
    display: flex;
    align-items: flex-start;
    gap: 2rem;
    .info_col {
      flex: 1 1 0;
      min-width: 0;
    }
    .timeline_col {
      flex: 0 0 320px;
      max-width: 320px;
    }
    @media (max-width: 900px) {
      flex-direction: column;
      gap: 1rem;
      .timeline_col {
        flex: 1 1 auto;
        max-width: 100%;
        width: 100%;
      }
    }
  }
  .block_section {
    margin-bottom: 1rem;
    .title {
      margin-bottom: 0.25rem;
    }
    .body {
      .value_item_wrap {
        .edit_row {
          display: flex;
          align-items: center;
          column-gap: 2.5rem;
        }
      }
      .slip_list {
        display: flex;
        flex-wrap: wrap;
        gap: 1rem;
        .slip_item {
          position: relative;
          .slip_img {
            width: 200px;
            height: 200px;
            border-radius: 12px;
            box-shadow: 1px 3px 10px -4px rgb(0 0 0 / 45%);
            object-fit: cover;
            cursor: pointer;
            transition: transform 0.3s ease;
            &:hover {
              transform: scale(1.05);
            }
          }
          .btn_delete_slip {
            position: absolute;
            top: 0;
            right: 0;
            padding: 0.5rem;
            background: transparent;
            cursor: pointer;
            z-index: 1;
          }
        }
      }
    }
  }
  .timeline_wrap {
    display: flex;
    flex-direction: column;
    .timeline_item {
      position: relative;
      padding-left: 1.75rem;
      padding-bottom: 1.25rem;
      &:before {
        content: "";
        position: absolute;
        left: 5px;
        top: 4px;
        bottom: 0;
        width: 2px;
        background: #e0e0e0;
      }
      &:last-child {
        padding-bottom: 0;
        &:before {
          display: none;
        }
      }
      .timeline_dot {
        position: absolute;
        left: 0;
        top: 2px;
        width: 12px;
        height: 12px;
        border-radius: 50%;
        background: #c4c4c4;
        z-index: 1;
      }
      .timeline_body {
        .timeline_action {
          font-weight: 600;
        }
        .timeline_meta {
          font-size: 0.8rem;
          color: #888;
          margin-top: 0.1rem;
        }
        .timeline_note {
          font-size: 0.85rem;
          color: #555;
          margin-top: 0.2rem;
        }
      }
    }
    .timeline_empty {
      color: #888;
      font-size: 0.9rem;
    }
  }
  .btn_regis_wrap {
    max-width: 190px;
  }
  .button_wrap {
    max-width: 150px;
    margin-left: auto;
    margin-right: 0px;
  }
`;
